// extracted by mini-css-extract-plugin
export var fadeInOut = "_2y-3";
export var icon = "_2y-4";
export var savedIndicator = "_2y-2";
export var savingIndicator = "_2y-0";
export var spin = "_2y-1";